import { render, staticRenderFns } from "./tr-3.vue?vue&type=template&id=05bd445b&"
import script from "./tr-3.vue?vue&type=script&lang=ts&"
export * from "./tr-3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports